import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { HANDLE_HTTP_ERROR_LOCALLY } from "../../../../shared/error/http-error-context";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        !req.context.get(HANDLE_HTTP_ERROR_LOCALLY) &&
        error.status >= 500 &&
        error.status < 600
      ) {
        router.navigate(["/pia/error"]);
      }

      return throwError(() => error);
    }),
  );
};
